export default class ReportingGroupPathDto {

    ReportingGroupPathId: number;
    PathId: number;
    PathName: string;

    constructor(reportingGroupPathId: number, pathId: number, pathName: string) {
        this.ReportingGroupPathId = reportingGroupPathId;
        this.PathId = pathId;
        this.PathName = pathName;
    }
}
